// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BoardListSkeleton_wrapper__wVOjs","list":"BoardListSkeleton_list__lK_9t","image-wrapper":"BoardListSkeleton_image-wrapper__v5XAF","text":"BoardListSkeleton_text__JNaoa"};